// src/context/AuthContext.js
import React, { createContext, useContext, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  // const navigate = useNavigate();
  const initialToken = localStorage.getItem("token");
  const initialRole = localStorage.getItem("role");
  const [isAuthenticated, setIsAuthenticated] = useState(!!initialToken);
  const [role, setRole] = useState(initialRole);
  const login = (token, userRole) => {
    localStorage.setItem("token", token);
    localStorage.setItem("role", userRole);
    setIsAuthenticated(true);
    setRole(userRole);
  };

  const logout = () => {
    localStorage.clear();
    window.location.href = "/login";
  };

  useEffect(() => {
    // Check if the token is // localStorage.removeItem("token");
    // localStorage.removeItem("role");
    // // setIsAuthenticated(false);
    // setRole(null); present in localStorage
    const token = localStorage.getItem("token");
    setIsAuthenticated(!!token);
  }, []);

  return (
    <AuthContext.Provider value={{ isAuthenticated, role, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
